module.exports = __webpack_public_path__ + "img/close.dc769aab.svg";